import { useState } from "react";
import { faqList, trustPoints } from "@/mocks/guaNews";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
        {/* trust */}
        <div>
          <h4 className="text-sm font-semibold text-secondary-700">
            <a href="#faq" className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-base"></i>
              Why Trust Us
            </a>
          </h4>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们怎么保证看得明白、信得过</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            做吃瓜速览，最怕真假难辨。五1吃瓜在整理今日爆料与最新瓜时坚持几条底线，让内容既可看也可回查。
          </p>

          <div className="mt-6 grid gap-4 sm:grid-cols-2">
            {trustPoints.map((p) => (
              <div key={p.title} className="rounded-2xl bg-background-100 p-4 ring-1 ring-inset ring-background-200/60">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1 text-xs leading-5 text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* faq accordion */}
        <div>
          <h4 className="text-sm font-semibold text-accent-700">
            <a href="#faq" className="inline-flex items-center gap-1.5">
              <i className="ri-question-line text-base"></i>
              FAQ
            </a>
          </h4>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>

          <div className="mt-6 divide-y divide-background-200/70 rounded-2xl bg-background-100 ring-1 ring-inset ring-background-200/60">
            {faqList.map((item, idx) => {
              const open = openIdx === idx;
              return (
                <div key={idx}>
                  <button
                    onClick={() => setOpenIdx(open ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-[15px] font-semibold text-foreground-900">{item.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${open ? "ri-subtract-fill" : "ri-add-fill"}`}
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}